import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Menu from "../ui/Menu";
import { ROUTES } from "../utils/Routes";
import { createScreen } from "../hooks/createScreen";
import { kbdEvent, runEvent } from "../utils/Utils";

export default function CustomerExtra(props) {

    const { controller = "", callback = () => { }, route = "", signal = {} } = props;

    const menu = [
        { text: "Alert message (add/edit/delete)", key: KBD.A, option: "A", action: () => callback("A")},
        { text: "Merge this customer with another", key: KBD.M, option: "M", action: () => callback("M") },
        { text: "Shipping addresses", key: KBD.S, option: "S", action: () => callback("S") },
        { text: "Recalculate all customers annual sales", key: KBD.R, option: "R", action: () => callback("R") },
    ]

    const [selected, setSelected] = useState("A");

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            {
                key: KBD.ENTER, action: (e) => {
                    {
                        callback(selected)
                    }
                }
            },
        ];
        const cleanup = listen(controller, route, actions.concat(menu));
        return cleanup;
    }, [selected]);

    return (
        <div style={{ "width": "550px" }}>
            <div className="shim" /><div className="shim" />
            <Menu controller={controller} callback={(e) => callback(e.sort)} bordered keyName="option" show_keys setSelected={setSelected} selected={selected} menu={menu} route={route} />
        </div>
    )

}